import { ApiPeriodGroup } from '../../../redux/context/actions'

const driverDataQueryKeys = {
  all: [{ scope: 'driverData' }] as const,
  lists: () => [{ ...driverDataQueryKeys.all[0], entity: 'list' }] as const,
  list: (companyId: string, budgetingScenarioId?: number | null, periodGroups?: ApiPeriodGroup[]) =>
    [{ ...driverDataQueryKeys.lists()[0], companyId, budgetingScenarioId, periodGroups }] as const
}

export default driverDataQueryKeys
